<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="container">
            
            <mat-form-field  appearance="fill">
              <mat-label>Module Json Code</mat-label>
              <textarea matInput [(ngModel)]="Module"   [ngModelOptions]="{standalone: true}"
                        ></textarea>
            </mat-form-field>
            <button type="button" class="btn btn-primary" (click)="addModule()">Add Module</button>
            <div class="table-responsive mt-4">
              <table mat-table [dataSource]="AllModules" class="mat-elevation-z8 mt-3 table">
            
                <!-- Cluster Name Column -->
                <ng-container matColumnDef="Name">
                  <th mat-header-cell *matHeaderCellDef> Module Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>
                        
                <!-- Action Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- <button mat-raised-button (click)="Edit(element)">
                      <i class="material-icons">edit</i>
                    </button> -->
                    <button mat-raised-button (click)="DeleteModule(element)">
                      <i class="material-icons">delete</i>
                    </button>
                  </td>
                </ng-container>
            
                <!-- Table rows -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
              </table>
            </div>
            
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
